import React from 'react'

const TriangleCompetency = props => {
  return (
    <svg
      width='16'
      height='14'
      fill='none'
      viewBox='0 0 16 14'
      {...props}
    >
      <path fill='#fff' d='M8 0l7.794 13.5H.206L8 0z' />
    </svg>
  )
}

export default TriangleCompetency
